import { apiNode } from './api'
import type { GetPricingRegionResponse } from './types/pricing.interfaces'

const URL = '2/pricing'

export const PricingService = {
	async getPricingRegion(): Promise<GetPricingRegionResponse> {
		const response = await apiNode.get<GetPricingRegionResponse>(
			`${URL}/region`,
		)

		return response.data
	},
}
